import { IconCuttery, IconDiamondNew, IconEntertainment, IconHat, IconHeartBeat, IconHome, IconTechnology, } from 'design-system/icons';
import { IconHoliday } from 'design-system/icons/IconHoliday';
import { RewardTypes } from 'reducers/types';
export const REWARD_TYPES = {
    [RewardTypes.Popular]: {
        id: RewardTypes.Popular,
        text: 'Popular',
    },
    [RewardTypes.TopOffers]: {
        id: RewardTypes.TopOffers,
        text: 'Top offers',
    },
    [RewardTypes.NewOffers]: {
        id: RewardTypes.NewOffers,
        text: 'New offers',
    },
    [RewardTypes.Travel]: {
        id: RewardTypes.Travel,
        icon: IconHoliday,
        text: 'Travel',
    },
    [RewardTypes.Home]: {
        id: RewardTypes.Home,
        icon: IconHome,
        text: 'Home',
    },
    [RewardTypes.Fashion]: {
        id: RewardTypes.Fashion,
        icon: IconHat,
        text: 'Fashion',
    },
    [RewardTypes.Food]: {
        id: RewardTypes.Food,
        icon: IconCuttery,
        text: 'Food & drink',
    },
    [RewardTypes.Health]: {
        id: RewardTypes.Health,
        icon: IconHeartBeat,
        text: 'Health & fitness',
    },
    [RewardTypes.Entertainment]: {
        id: RewardTypes.Entertainment,
        icon: IconEntertainment,
        text: 'Entertainment',
    },
    [RewardTypes.Tech]: {
        id: RewardTypes.Tech,
        icon: IconTechnology,
        text: 'Tech',
    },
    [RewardTypes.Beauty]: {
        id: RewardTypes.Beauty,
        icon: IconDiamondNew,
        text: 'Beauty',
    },
};
